import { typeOf } from './basics'
import { IObject } from './interface'

const _EMPTY = Symbol('empty') // 空，用于占位，不进行任何操作
const _END = Symbol('end') // 结束，用于数组的最后一个元素
const _DELETE = Symbol('delete') // 删除，用于删除属性
type assignType = {
  (...param: any[]): void
  empty: Symbol
  end: Symbol
  delete: Symbol
}
const assign: assignType = function (...args: IObject[]) {
  const obj = args.reduce((target, sources) => {
    if (
      (typeof target !== 'object' ||
      typeof sources !== 'object' ||
      typeOf(target) !== typeOf(sources))
    ) {
      return sources // 如果其中一个不是对象 就返回sources
    }
    const flag: {length?: number | string, _DELETE?: (string | number)[]} = {}
    for (const key in sources) {
      if (sources[key] === _EMPTY) continue
      if (sources[key] === _END && typeOf(sources) === 'array') {
        flag.length = key
        continue
      }
      if (sources[key] === _DELETE) {
        flag._DELETE = flag._DELETE || []
        flag._DELETE.unshift(key)
        continue
      }
      // 如果target也存在 那就再次合并
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        if (typeOf(target[key]) === 'object') {
          target[key] = assign({}, target[key], sources[key])
        } else if (typeOf(target[key]) === 'array') {
          target[key] = assign([], target[key], sources[key])
        } else {
          target[key] = assign(target[key], sources[key])
        }
      } else {
        // 不存在就直接添加
        target[key] = sources[key]
      }
    }
    if (flag._DELETE) {
      for (const key of flag._DELETE) { // 使用for of 遍历
        if (typeOf(target) === 'object') delete target[key]
        if (typeOf(target) === 'array') (target as any[]).splice(+key, 1)
      }
      delete flag._DELETE
    }
    if (flag.length) {
      (target as (any[]|{[p: string]: any})).length = +flag.length
      delete flag.length
    }
    return target
  })
  return obj
}
assign.empty = _EMPTY
assign.end = _END
assign.delete = _EMPTY
// 添加只读属性
Object.defineProperty(assign, 'empty', {
  value: _EMPTY,
  writable: false
})

Object.defineProperty(assign, 'end', {
  value: _END,
  writable: false
})

Object.defineProperty(assign, 'delete', {
  value: _DELETE,
  writable: false
})

// TODO:还未实现
// function assignTruthy(...args) {
//   const obj = args.reduce((target, sources) => {
//     if (!sources) {
//       return target
//     }
//     if (
//       typeof target !== 'object' ||
//       typeof sources !== 'object' ||
//       typeOf(target) !== typeOf(sources)
//     ) {
//       return sources // 如果其中一个不是对象 就返回sources
//     }
//     for (const key in sources) {
//       // 如果target也存在 那就再次合并
//       if (Object.prototype.hasOwnProperty.call(target, key)) {
//         if (typeOf(target[key]) === 'object') {
//           target[key] = assignTruthy({}, target[key], sources[key])
//         } else if (typeOf(target[key]) === 'array') {
//           target[key] = assignTruthy([], target[key], sources[key])
//         } else {
//           target[key] = assignTruthy(target[key], sources[key])
//         }
//       } else {
//         // 不存在就直接添加
//         target[key] = sources[key]
//       }
//     }
//     return target
//   })
//   return obj
// }
export {
  assign,
  // assignTruthy
}
export default {
  assign, // 通过id找到自身对象和父级对象或数组
  // assignTruthy,
}